import type { CmdHistory } from '../CmdHistory.js';

export function createCmdHistory(): CmdHistory {
	return {
		a: null,
		b: null,
	};
}
